<ng-container *ngIf="showExternalNoteField; else externalNote">
  <form [formGroup]="form" data-test-id="appointment-external-note-form">
    <div class="text-size-[14px] font-bold mb-[3px]">
      {{ 'bookingPage.confirmAppointmentPage.guestSection.form.comment.label' | translate }}
    </div>
    <textarea
      nz-input
      placeholder="{{ 'bookingPage.confirmAppointmentPage.guestSection.form.comment.placeholder' | translate }}"
      class="external-note-field"
      formControlName="externalNote"
      rows="4"
      (change)="changeExternalNoteField()"
      #externalNoteField
      data-test-id="appointment-external-note-textarea"></textarea>
  </form>
</ng-container>

<ng-template #externalNote>
  <div class="flex flex-col mt-[10px]" data-test-id="appointment-external-note-block" *ngIf="externalNote$ | async as note" >
    <h3 class="text-[20px] font-medium mb-[8px]">
      {{ 'bookingPage.thankYouPage.customerComment' | translate }}
    </h3>
    <span class="font-medium leading-[24px] text-[14px]"> </span>
    <span data-test-id="appointment-external-note-text">{{ note }}</span>
  </div>
</ng-template>
